import { Paper, Stack, Typography } from "@mui/material";

interface NotesCardProps {
  title: string;
  content: string;
}

export default function NotesCard({ title, content }: NotesCardProps) {
  return (
    <Paper
      sx={{ bgcolor: "#f0f4f8", borderRadius: "10px", p: 1.5, boxShadow: 0 }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "14px",
            color: "#64748b",
          }}
        >
          {title}
        </Typography>
      </Stack>
      <Typography
        sx={{
          fontWeight: 400,
          fontSize: "12px",
          color: "#64748b",
          lineHeight: 1.5,
        }}
      >
        {content}
      </Typography>
    </Paper>
  );
}
